import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { SourceFormService } from 'features/project-form/features/source/service/service'

export { SourceFormService } from 'features/project-form/features/source/service/service'

export function useSourceFormService(): SourceFormService {
  const client = useApiClient()
  return useMemo(() => new SourceFormService(client), [client])
}
